export default __webpack_public_path__ + "static/media/Gorulga's Shield.b5cd3bee.jpg";